<template>
  <div class="col-xs-12 col-sm-10 default-list-contain-sty" v-if="!this.$parent.isLoadShow">
    <div>
      <div class="order-main-title-sty">
        <div class="order-main-title-sty">
          <h5>
            <span>
              服務日期 <b>{{orderInfo.roc_date}}</b>
            </span>
            <span style="margin-left:25px;">
              服務金額 <b>{{orderInfo.raw_cash}}</b>
            </span>
            <span @click="goToCurrentOrder" class="rs-icon-btn-sty float-right"><i class="rs-icon-default rs-icon-readorder rs-icon-color-green1"></i></span></h5>
        </div>
        <!-- <div  class="order-sub-title-sty row">
          <div class="col-6">
            <span>服務日期 {{orderInfo.roc_date}}</span>
          </div>
          <div class="col-6">
            <span>服務金額 <b>{{orderInfo.raw_cash}}</b> </span>
          </div>
        </div> -->
      </div>
      <hr>
      <div class="order-contain">
        <div>
          <div>
            <p>
              服務完成! <br/>
              如果方便還請麻煩不吝指教<br/>
              您的評價對我們很重要!
            </p>
          </div>
          <div v-for="(scoption, index) in scoreOptions" :key="index">
            <div class="form-group">
              <label
              :id="'score_op_' + index"
              :label-for="'score_val_' + index"
              >
                <b>{{ scoption. label}}</b><span style="padding-left: 15px;">{{scoption.desc}}</span>
              </label>
              <div class="row">
                <b-form-rating :id="'score_val_' + index" v-model="submitArray[index].score" inline no-border size="lg" class="re-order-input-sty col-10"></b-form-rating>
                <b-form-input
                :id="'score_valinput_' + index"
                v-model="submitArray[index].score"
                class="re-order-input-sty col-2"
                type="number"
                disabled
                style="background-color: transparent;"
                ></b-form-input>
              </div>
              <!-- <b-form-input
              :id="'score_feaback_' + index"
              v-model="submitArray[index].feedback"
              class="re-order-input-sty col-md-12"
              placeholder="關於這個項目有甚麼想要跟我們反映或補充的呢?"
              ></b-form-input> -->
            </div>
          </div>
          <b-form-group>
            <label
              id="score_feedback_label"
              label-for="score_feedback"
              >
                <b>用戶回饋</b>
              </label>
            <b-form-textarea
            id="score_feedback"
            v-model="scoreFeedback"
            size="md"
            placeholder="把這次體驗的感受和我們分享吧"
            class="re-order-input-sty"
            lazy-formatter
            rows="5"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </div>
      <div class="order-footer-contain text-right">
        <b-button
            class="text-white order-info-btn-sty"
            variant="info"
            size="md"
            @click="checkSubmit">
            送出評價
        </b-button>
      </div>
    </div>
    <b-modal id="rsSorceSucess" ref="rssorcesucess-modal">
      <template>
        <div class="row">
          <span>評分成功送出!</span>
          <span>十分感謝您的回饋，期待下次與您的相遇</span>
        </div>
      </template>
      <template #modal-footer>
        <b-button size="lg" variant="info" @click="closeLiff()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'OrderScore',
  props: {
    userId: String,
    userType: String,
    orderId: String
  },
  data () {
    return {
      orderInfo: {},
      scoreOptions: [],
      submitArray: [],
      scoreFeedback: null
    }
  },
  created () {
    this.$nextTick(() => {
      this.getScoreOptions()
      this.getOrderInfo()
    })
  },
  watch: {
  },
  methods: {
    getScoreOptions () {
      const self = this
      const getUrl = this.$apiDoc.apiGetScoreOptions
      this.$api.get(getUrl, {}).then((resp) => {
        if (resp.result) {
          self.scoreOptions = resp.data
          self.initSubmitArray()
        }
      }).catch((errorInfo) => {})
    },
    getOrderInfo () {
      const self = this
      const getUrl = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$parent.isLoadShow = true
      this.$api.get(getUrl, {}).then((resp) => {
        if (resp.result) {
          self.orderInfo = self.arrangeOrderData(resp.data)
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
          self.$parent.isLoadShow = false
        }
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        alert(errorMsg)
        self.$parent.isLoadShow = false
      })
    },
    arrangeOrderData (data) {
      if (data) {
        data.orderPt = '/' + this.$props.userType + this.$apiDoc.routerOrderInfo + '#' + this.orderId
      }
      this.$parent.isLoadShow = false
      return data
    },
    initSubmitArray () {
      const self = this
      this.submitArray = []
      if (this.scoreOptions.length > 0) {
        this.scoreOptions.forEach((op) => {
          var item = {}
          item.id = op.id
          item.score = null
          item.feedback = null
          self.submitArray.push(item)
        })
      }
    },
    goToCurrentOrder () {
      if (this.orderInfo && this.orderInfo.orderPt) {
        this.$router.push({ path: this.orderInfo.orderPt, replace: true })
        location.reload()
      }
    },
    verifyRating (index) {
      var currentObj = this.submitArray[index]
      var currentScore = parseFloat(currentObj.score)
      var numberArray = []
      if (currentScore > 5) {
        currentScore = 5
      }
      if (!isNaN(currentScore)) {
        currentScore = currentScore.toFixed(1)
        numberArray = currentScore.toString().split('.')
        if (numberArray[1] > 5 || (numberArray[1] < 5 && numberArray[1] > 0)) {
          if (numberArray[1] > 5) {
            numberArray[1] = 5
          } else {
            if (numberArray[1] < 5 && numberArray[1] > 0) {
              numberArray[1] = 0
            }
          }
          currentScore = parseFloat(numberArray.join('.'))
        }
        this.submitArray[index].score = currentScore
      }
    },
    checkSubmit () {
      const self = this
      var isCorrect = true
      var emptyArray = []
      this.submitArray.forEach((item, index) => {
        if (item.score === null) {
          emptyArray.push(index)
          if (isCorrect) {
            isCorrect = false
          }
        }
        // if (!isCorrect && index === (self.submitArray.length - 1)) {
        //   if (self.scoreFeedback) {
        //     isCorrect = true
        //   }
        // }
      })
      if (isCorrect) {
        this.submitScore()
      } else {
        self.$bvToast.toast('如果方便還請麻煩不吝指教，您的評價對我們很重要!', {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'default',
          solid: true
        })
        emptyArray.forEach((num) => {
          var target = this.$el.querySelector('#score_op_' + num)
          if (!target.classList.contains('order-input-danger')) {
            target.classList.add('order-input-danger')
          }
        })
        setTimeout(() => {
          emptyArray.forEach((num) => {
            var target = this.$el.querySelector('#score_op_' + num)
            if (target.classList.contains('order-input-danger')) {
              target.classList.remove('order-input-danger')
            }
          })
        }, 3000)
      }
    },
    submitScore () {
      const self = this
      const url = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiPostScore
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var options = {}
      options.score_items = this.submitArray
      options.score_feedback = this.scoreFeedback
      this.$api.post(url, options).then((resp) => {
        self.$bvModal.show('rsSorceSucess')
      }).catch((errorInfo) => {
        errorMsg = self.$toolDoc.convertErrorMsg(errorInfo)
        self.$bvToast.toast(errorMsg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
      })
    },
    closeLiff () {
      this.$liff.closeWindow()
    }
  }
}
</script>
